import React from 'react'
import styles from './vbox.module.css'

export default ({ children, widegap }) => (
  <div className={widegap ? styles.vboxwide : styles.vbox} >{children}</div> 
)
